<template> 
  <div id="main">
    <v-container class="d-flex justify-center align-center">
  <div class="d-flex flex-column" style="width: 100%;">
    <v-card flat class="mb-4" v-if="isAdmin" >
      <v-radio-group row dense hide-details="auto" v-model="assignedCategory">
        <div v-for="(item,x) in categories" :key="x">
          <v-radio :label="$t(`categories.${item}`)" :value="item"></v-radio>
        </div>
      </v-radio-group>
    </v-card>
    <!-- Wrap date pickers and buttons in a flex container with fixed spacing -->
    <div class="d-flex flex-row align-center" style="flex-wrap: wrap; gap: 12px;">
      <c-date-picker
        class="mr-2"
        append-icon="mdi-calendar"
        :label="$t('plannerCodeRange.fromDate')"
        dense outlined hide-details="auto"
        @input="validateDateRange()"
        v-model="plannerCodeRange.fromDate"
        style="min-width: 150px;"
      ></c-date-picker>
      <c-date-picker
        class="mr-2"
        append-icon="mdi-calendar"
        :label="$t('plannerCodeRange.toDate')"
        dense outlined hide-details="auto"
        :max="monthRestriction"
        @input="validateDateRange()"
        v-model="plannerCodeRange.toDate"
        style="min-width: 150px;"
      ></c-date-picker>
      
      <!-- Sales Office Autocomplete -->
      <v-autocomplete
        v-if="isAdmin && showSalesOfficeSelection"
        class="mr-2"
        outlined
        hide-details="auto"
        dense
        :items="salesOfficeItems"
        :loading="salesOfficeLoader"
        style="max-width: 15%; min-width: 200px;"
        v-model="selectedSalesOffice"
        :label="$t('PlannersInfo.SalesOfficeName')"
        :item-text="item => `${item.SalesOfficeCode} - ${item.SalesOfficeName}`"
        item-code="SalesOfficeCode"
        return-object
        @change="getPlannerItems()"
      ></v-autocomplete>

      <!-- Planner Autocomplete -->
      <v-autocomplete
        v-if="showPlannerSelection"
        class="mr-2"
        outlined
        maxlength="5"
        dense
        :loading="plannersLoader"
        :items="plannerItems"
        hide-details="auto"
        :item-text="item => `${item.EmployeeCode} - ${item.EmployeeName}`"
        item-code="EmployeeCode"
        :label="$t('plannerCodeRange.PlannerCode')"
        v-model="selectedPlanner"
        style="max-width: 15%; min-width: 150px;"
        return-object
        @change="combinedCadData.length > 0 ? loadData() : ''"
      ></v-autocomplete>
      <!-- Generate Button -->
      <v-btn
        class="mr-5"
        @click="loadData()"
        xxl
        :style="{ color: 'white' }"
        color="#0D47A1"
        style="min-width: 100px;"
      >{{$t(`generate.generate`)}}</v-btn>

      <!-- CSV Button -->
      <v-btn
        v-if="cadData.length > 0"
        @click="printCSV()"
        xxl
        :style="{ color: 'white' }"
        color="#0D47A1"
        style="min-width: 100px;"
      >{{$t(`generate.generateCSV`)}}</v-btn>
    </div>
  </div>
</v-container>
    <v-card flat class="mx-6" v-if="cadData.length > 0">
      <v-simple-table dense v-if="!isAdmin || hasEmployeeSelected">
        <thead class="light-blue darken-4">
          <tr>
            <th class="white--text text-center font-weight-regular borderStyle" colspan="4">{{ $t(`PlannersInfo.SalesOfficeName`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle" colspan="4">{{ $t(`PlannersInfo.BranchName`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle" colspan="4">{{ $t(`PlannersInfo.PlannersName`)}}</th>
          </tr>
        </thead>
        <tbody class="indigo lighten-5">
          <tr v-for="(item,i) in cadData" :key="i">
            <td class="text-center font-weight-regular borderStyle" colspan="4">{{ item.salesOfficeName || '—' }}</td>
            <td class="text-center font-weight-regular borderStyle" colspan="4">{{ item.branchName || '—' }}</td>
            <td class="text-center font-weight-regular borderStyle" colspan="4">{{ item.employeeName }}</td>
          </tr>
        </tbody>
      </v-simple-table >
      <v-simple-table id="tableAverageRef" dense class="my-2 borderStyle" height="235" @scroll="onScrollAverage">
        <thead class="light-blue darken-4 sticky-thead" style="top: 0px;">
          <tr>
            <th v-if="isAdmin" class="white--text text-center font-weight-regular borderStyle pa-1" width="5%" rowspan="2">{{$t(`PlannersInfo.SalesOfficeCode`)}}</th>
            <th v-if="isAdmin" class="white--text text-center font-weight-regular borderStyle pa-1" width="7%" rowspan="2">{{$t(`header.SalesOffice`)}}</th>
            <th v-if="isAdmin" class="white--text text-center font-weight-regular borderStyle pa-1" width="5%" rowspan="2">{{$t(`PlannersInfo.EmployeeCode`)}}</th>
            <th v-if="isAdmin" class="white--text text-center font-weight-regular borderStyle pa-1" width="7%" rowspan="2">{{$t(`PlannersInfo.EmployeeName`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="15.5%" rowspan="2" colspan="2">{{$t(`header.Category`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" colspan="4">{{$t(`header.No of CAD`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" colspan="2">{{$t(`header.Denki Plan`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{$t(`header.Color Perspective`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{'HP'}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{$t(`header.Structural Investigation(Waku)`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{$t(`header.Structural Investigation(Jiku)`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{'ALVS'}}</th>
          </tr>
          <tr>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.Total`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.CADPDR`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.CADFinal`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.CADExpress`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.Total`)}}</th>
            <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.DenkiExpress`)}}</th>
          </tr>
        </thead>
        <thead class="indigo lighten-5" v-for="(item, index) in cadData" :key="index">
          <tr>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeCode || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeName || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeCode }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeName }}</th>
            <th class="text-center font-weight-regular borderStyle pa-1" colspan="2">{{ $t(`Average.Average Number of Requests`) }}</th>
            <th
              class="text-center font-weight-regular borderStyle pa-1"
              v-for="(value, key) in item.average" :key="'average-' + key"
            >
              <v-tooltip top color="primary" style="z-index: 3" v-if="!['cadPdr', 'cadFinalPlan', 'cadExpress'].includes(key)">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ value }}</span>
                </template>
                <span>
                  <b>{{$t(`tooltip.Category`)}}:</b> {{$t(`tooltip.Planner`)}}<br>
                  <b>{{$t(`tooltip.Formula`)}}:</b> {{ 
                    key === 'cad' ? $t(`tooltip.Total CAD Request`)
                    : key === 'denki' || key === 'denkiExpress' ? $t(`tooltip.Total Denki Request`)
                    : key === 'externalPers' ? $t(`tooltip.Total Color Perspective Request`)
                    : key === 'hp' ? $t(`tooltip.Total HP Request`)
                    : key === 'siWaku' ? $t(`tooltip.Total SI(Waku) Request`)
                    : key === 'siJiku' ? $t(`tooltip.Total SI(Jiku) Request`)
                    : key === 'alvs' ? $t(`tooltip.Total ALVS Request`)
                    : ''
                  }} / {{$t(`tooltip.Total Kakou-irai`)}}
                </span>
              </v-tooltip>
              <span v-else>{{ value }}</span>
            </th>
          </tr>
          <tr>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeCode || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeName || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeCode }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeName }}</th>
            <th class="text-center font-weight-regular borderStyle pa-1" colspan="2">{{ $t(`Average.EIGYOUSYO Average`) }}</th>
            <th
              class="text-center font-weight-regular borderStyle pa-1"
              v-for="(value, key) in item.branchAverage" :key="'branchAverage-' + key"
            >
              <v-tooltip top color="primary" style="z-index: 3" v-if="!['cadPdr', 'cadFinalPlan', 'cadExpress'].includes(key)">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ value }}</span>
                </template>
                <span>
                  <b>{{$t(`tooltip.Category`)}}:</b> {{$t(`tooltip.Sales Office`)}}<br>
                  <b>{{$t(`tooltip.Formula`)}}:</b> {{
                    key === 'cad' ? $t(`tooltip.Total CAD Request`)
                    : key === 'denki' || key === 'denkiExpress' ? $t(`tooltip.Total Denki Request`)
                    : key === 'externalPers' ? $t(`tooltip.Total Color Perspective Request`)
                    : key === 'hp' ? $t(`tooltip.Total HP Request`)
                    : key === 'siWaku' ? $t(`tooltip.Total SI(Waku) Request`)
                    : key === 'siJiku' ? $t(`tooltip.Total SI(Jiku) Request`)
                    : key === 'alvs' ? $t(`tooltip.Total ALVS Request`)
                    : ''
                  }} / {{$t(`tooltip.Total Kakou-irai`)}}
                </span>
              </v-tooltip>
              <span v-else>{{ value }}</span>
            </th>
          </tr>
          <tr>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeCode || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeName || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeCode }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeName }}</th>
            <th class="text-center font-weight-regular borderStyle pa-1" colspan="2">{{ $t(`Average.EIGYOUSYO Ranking`) }}</th>
            <th
              class="text-center font-weight-regular borderStyle pa-1"
              v-for="(value, key) in item.branchRank" :key="'branchRank-' + key"
            >
              <v-tooltip top color="primary" style="z-index: 3">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ value }}</span>
                </template>
                <span>{{$t(`tooltip.Current Rank in Sales Office`)}}</span>
              </v-tooltip>
            </th>
          </tr>
          <tr>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeCode || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeName || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeCode }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeName }}</th>
            <th class="text-center font-weight-regular borderStyle pa-1" colspan="2">{{ $t(`Average.ZENKOKU Average`) }}</th>
            <th
              class="text-center font-weight-regular borderStyle pa-1"
              v-for="(value, key) in item.nationwideAverage" :key="'nationwideAverage-' + key"
            >
              <v-tooltip top color="primary" style="z-index: 3" v-if="!['cadPdr', 'cadFinalPlan', 'cadExpress'].includes(key)">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ value }}</span>
                </template>
                <span>
                  <b>{{$t(`tooltip.Category`)}}:</b> {{$t(`tooltip.Nationwide`)}}<br>
                  <b>{{$t(`tooltip.Formula`)}}:</b> {{
                    key === 'cad' ? $t(`tooltip.Total CAD Request`)
                    : key === 'denki' || key === 'denkiExpress' ? $t(`tooltip.Total Denki Request`)
                    : key === 'externalPers' ? $t(`tooltip.Total Color Perspective Request`)
                    : key === 'hp' ? $t(`tooltip.Total HP Request`)
                    : key === 'siWaku' ? $t(`tooltip.Total SI(Waku) Request`)
                    : key === 'siJiku' ? $t(`tooltip.Total SI(Jiku) Request`)
                    : key === 'alvs' ? $t(`tooltip.Total ALVS Request`)
                    : ''
                  }} / {{$t(`tooltip.Total Kakou-irai`)}}
                </span>
              </v-tooltip>
              <span v-else>{{ value }}</span>
            </th>
          </tr>
          <tr>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeCode || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.salesOfficeName || '—' }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeCode }}</th>
            <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.employeeName }}</th>
            <th class="text-center font-weight-regular borderStyle pa-1" colspan="2">{{ $t(`Average.ZENKOKU Ranking`) }}</th>
            <th
              class="text-center font-weight-regular borderStyle pa-1"
              :style="{ 'color' : getTextColor(value) }"
              v-for="(value, key) in item.nationwideRank" :key="'nationwideRank-' + key"
            >
              <v-tooltip top color="primary" style="z-index: 3">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ value }}</span>
                </template>
                <span>{{$t(`tooltip.Current Rank in Nationwide`)}}</span>
              </v-tooltip>
            </th>
          </tr>
        </thead>
      </v-simple-table>
        <v-simple-table id="tablePlanRef" dense class="borderStyle" :height="tableHeight" @scroll="onScrollPlan">
          <thead id="theadRef" class="light-blue darken-4 sticky-thead" style="top: 0px;">
            <tr>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" colspan="6">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ $t(`header.NoofKAkou`) }} : {{ totalCombinedData }}
                    </span>
                  </template>
                    <span>{{ totalCombinedCadData }}</span>
                </v-tooltip>
              </th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" colspan="11">{{$t(`header.No of Request`)}}</th>
            </tr>
          </thead>
          <thead class="light-blue darken-4 sticky-thead" :style="{ top: theadHeight + 'px'} ">
            <tr>
              <th v-if="isAdmin" class="white--text text-center font-weight-regular borderStyle pa-1" width="5%" rowspan="2">{{$t(`PlannersInfo.SalesOfficeCode`)}}</th>
              <th v-if="isAdmin" class="white--text text-center font-weight-regular borderStyle pa-1" width="7%" rowspan="2">{{$t(`header.SalesOffice`)}}</th>
              <th v-if="isAdmin" class="white--text text-center font-weight-regular borderStyle pa-1" width="5%" rowspan="2">{{$t(`PlannersInfo.EmployeeCode`)}}</th>
              <th v-if="isAdmin" class="white--text text-center font-weight-regular borderStyle pa-1" width="7%" rowspan="2">{{$t(`PlannersInfo.EmployeeName`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="7.75%" rowspan="2">{{$t(`header.CustomerCode`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="7.75%" rowspan="2">{{$t(`header.BuildingType`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" colspan="4">{{$t(`header.No of CAD`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" colspan="2">{{$t(`header.Denki Plan`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{$t(`header.Color Perspective`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{'HP'}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{$t(`header.Structural Investigation(Waku)`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{$t(`header.Structural Investigation(Jiku)`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%" rowspan="2">{{'ALVS'}}</th>
            </tr>
            <tr>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.Total`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.CADPDR`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.CADFinal`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.CADExpress`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.Total`)}}</th>
              <th class="white--text text-center font-weight-regular borderStyle pa-1" width="5.5%">{{$t(`header.DenkiExpress`)}}</th>
            </tr>
          </thead>
          <thead>
            <tr v-for="(item,x) in combinedCadData" :key="x">
              <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.SalesOfficeCode || '—' }}</th>
              <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.SalesOfficeName || '—' }}</th>
              <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.EmployeeCode }}</th>
              <th v-if="isAdmin" class="text-center font-weight-regular borderStyle pa-1">{{ item.EmployeeName }}</th>
              <th
                class="text-center font-weight-regular borderStyle pa-1"
                style="position: relative;"
                @mouseenter="hoverColumn(true, x)"
                @mouseleave="hoverColumn(false, x)"
              >
                <template>
                  <span :id="'constructionCode-' + x">{{ item.ConstructionCode }}</span>
                </template>
                <v-btn style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%);" @click="copyText(item.ConstructionCode, x)" x-small icon>
                  <v-fade-transition>
                    <v-icon v-show="copyIcon[x]">{{showText[x]? 'mdi-check': 'mdi-content-copy'}}</v-icon>
                  </v-fade-transition>
                </v-btn>
                <v-tooltip v-model="showText[x]" right transition="slide-x-transition">
                  <template v-slot:activator="{ on }">
                    <span v-on="on"></span>
                  </template>
                  <span>Copied!</span>
                </v-tooltip>
              </th>
              <th class="text-center font-weight-regular borderStyle pa-1">
                <v-tooltip right color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    >{{Array.isArray(splitChar(item.ConstructionTypeName)) ? splitChar(item.ConstructionTypeName)[0] : splitChar(item.ConstructionTypeName)}}
                    </span>
                    <span
                      style="display: block;"
                      v-bind="attrs"
                      v-on="on"
                    >{{Array.isArray(splitChar(item.ConstructionTypeName)) ? splitChar(item.ConstructionTypeName)[1] : ''}}
                    </span>
                  </template>
                  <span class="pa-1"> {{item.HouseType}}</span>
                </v-tooltip>
              </th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.cad}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.CadPdr == 0 ? item.CadDenkiPlan:item.CadPdr}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.CadFinalPlan}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.CadExpress}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.denki}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.denkiExpress}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.ExternalPers}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.House_presentation}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{`${item.SI_WAKU_DUCT==0 ? '':item.SI_WAKU_DUCT}`}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{`${item.SI_WAKU_DUCT != 0 ? item.SI_JIKU == 0 ? '': '': item.SI_JIKU}`}}</th>
              <th class="text-center font-weight-regular borderStyle pa-1">{{item.ALVS}}</th>
            </tr>
          </thead>
        </v-simple-table>
    </v-card>
    <v-card flat class="d-flex justify-center align-center mt-15" v-else variant="text">
      <img
        src="@/assets/Logo/CadRequest.png"
        style="width: '80%'; pointer-events: 'none'; user-select: 'none'"
        width="300vw" height="300vw"
      />
    </v-card>
    <Loader :loading="loading"/>
    <details-dialog ref="detailsDialog" :dialogData="'CADRequest'" :CADdata="cadData"></details-dialog>
  </div>
</template>

<script>
import CDatePicker from "../components/CDatePicker.vue";
import moment from 'moment';
import Swal from "sweetalert2";
// import _ from 'lodash';
import SalesOfficeClass from '../assets/class/salesOffice'
import PlannerCodeClass from '../assets/class/PlannersCode'
import MERGING from "../assets/class/SalesOfficeRanking/merging"
import PlannerData from '../assets/class/PlannerData/PlannerData.js'
import Loader from "../components/Loader.vue"
import axios from "axios";
  export default {
        components: { CDatePicker, Loader },
      data() {
          return {
              plannerData: new PlannerData(),
              salesOfficefunction: new SalesOfficeClass(),
              plannersCodefunction: new PlannerCodeClass(),
              plannerCodeRange: {
                      fromDate: moment().subtract(365,'days').format('YYYY-MM-DD'),
                      toDate: moment().format('YYYY-MM-DD'),
                      // fromDate:'2021-03-15',
                      // toDate:'2022-03-15',
                  },
              merge: new MERGING(),
              finalData:[],
              cadDetails:[],
              testlang:[],
              selectedSalesOffice: null,
              selectedPlanner: null,
              branchLength:[],
              salesLength:[],
              NationLength:[],
              showText:{},
              copyIcon: [],
              lastCopiedIndex: null,
              secondTheadTop: 0,
              tableHeight: window.innerHeight * 0.52,
              theadHeight: 0,
              assignedCategory: 'planner',
              categories: [
                'planner',
                'withSalesOffice',
                'allData'
              ],
              showPlannerSelection: false,
              showSalesOfficeSelection: false,
              loading:false,
              salesOfficeLoader:false,
              plannersLoader:false,
              salesOfficeItems:[],
              salesOfficeData:[],
              plannerItems:[],
              plannerInfo: {},
              cadData:[],
              combinedCadData:[],
              totalCombinedCadData: 0,
              totalCombinedData: 0,
              displayedData: [],
              loadCount: 30,
              page: {average: 1, plan: 1},
              wrapperPlanRef: null,
              wrapperAverageRef: null,
          }
      },
      methods: {
        details(){
          this.$refs.detailsDialog.openDialog();
        },
        getTableHeight() {
          if (this.combinedCadData.length <= 10) {
            this.tableHeight = 'auto';
            return;
          }
          const simpleTable = document.querySelector('#tablePlanRef');
          const header1 = document.querySelector('#theadRef');
          if (header1) {
            this.theadHeight = header1.getBoundingClientRect().height;
          }

          if (simpleTable) {
            const height = simpleTable.getBoundingClientRect().height + 15;
            const distanceFromTop = simpleTable.getBoundingClientRect().top;
            const tableHeightToBottom = window.innerHeight - distanceFromTop;
            const simpleTableHeight = tableHeightToBottom - 15;
            this.tableHeight = tableHeightToBottom < height ? simpleTableHeight : 'auto';
          }
        },
        splitChar(data) {
          if (data.includes('(')) {
            const parts = data.split('(');
            return [parts[0], '(' + parts.slice(1).join('(')];
          } else {
            return data;
          }
        },
        copyText(textToCopy, index) {
          this.$set(this.showText, index, true);

          const constructionCodeElement = this.$el.querySelector(`#constructionCode-${index}`);
          constructionCodeElement.classList.add('simulate-text-highlight');

          // Remove the highlight for the last copied index (if any)
          if (this.lastCopiedIndex !== null) {
            const lastCopiedElement = this.$el.querySelector(`#constructionCode-${this.lastCopiedIndex}`);
            lastCopiedElement.classList.remove('simulate-text-highlight');
          }

          setTimeout(() => {
            this.$set(this.showText, index, false);
            constructionCodeElement.classList.remove('simulate-text-highlight');
          }, 800);

          const textarea = document.createElement('textarea');
          textarea.value = textToCopy;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);

          // Update the last copied index
          this.lastCopiedIndex = index;
        },
        hoverColumn(val, index){
          this.$set(this.copyIcon, index, val);
        },
        setSecondTheadTop() {
          this.$nextTick(() => {
            if(this.$refs.firstThead){
              const firstTheadRect = this.$refs.firstThead.getBoundingClientRect();
                const firstTheadHeight = firstTheadRect.height;
                this.secondTheadTop = firstTheadHeight;
            }
          })
        },
        getTextColor(value){
          const rank = value.split('/')[0]
          const isBelow100 = parseInt(rank, 10) > 100;
          return isBelow100 ? 'red' : ''
        },
        validateDateRange() {
          const fromDate = this.plannerCodeRange.fromDate;
          const toDate = this.plannerCodeRange.toDate;
          const diffDay = parseInt(moment.duration(moment(toDate, "YYYY-MM-DD").diff(moment(fromDate, "YYYY-MM-DD"))).asDays());
          if (diffDay > 365) {
            Swal.fire({
              icon: "warning",
              title: `${this.$i18n.locale =='ja'?'エラー' :'Warning' }`,
              text: `${this.$i18n.locale =='ja'?' 開始日から終了日までの期間が1年以内の期間になるように入力し直してください。' :'Please re-enter so that the period from the start date to the end date is within one year.!'}`,
            });
            // Reset dates
            this.plannerCodeRange.toDate = moment().format('YYYY-MM-DD');
            this.plannerCodeRange.fromDate = moment().subtract(365, 'days').format('YYYY-MM-DD');
          } else {
            this.fetchData();
          }
        },
        fetchData() {
          this.selectedPlanner = null
          this.selectedSalesOffice = null
          if (!this.isAdmin && this.assignedCategory === 'planner') {
            this.getPlanners()
          } else {
            this.getSalesOffices()
          }
        },
        async getPlanners() {
          this.showPlannerSelection = true
          this.plannersLoader = true
          const obj = {
            employeeCode: this.userInfo['custom:emp_code'],
            from: this.plannerCodeRange.fromDate,
            to: this.plannerCodeRange.toDate
          }
          const { data } = await axios.post(`${this.ichijoApi}getPlanners`, obj, this.userInfo.tokenHeader)
          this.plannerItems = data
          this.plannersLoader = false
        },
        async getSalesOffices() {
          this.showSalesOfficeSelection = true
          this.showPlannerSelection = true
          this.salesOfficeLoader = true
          const obj = {
            userCategory: this.userInfo['custom:user_category'],
            from: this.plannerCodeRange.fromDate,
            to: this.plannerCodeRange.toDate
          }
          const { data } = await axios.post(`${this.ichijoApi}getSalesOffices`, obj, this.userInfo.tokenHeader)
          const salesOfficeGroups = new Map();
          data.forEach(x => {
            if (!salesOfficeGroups.has(x.SalesOfficeCode)) {
              salesOfficeGroups.set(x.SalesOfficeCode, {
                SalesOfficeCode: x.SalesOfficeCode ?? '',
                SalesOfficeName: x.SalesOfficeName ?? '',
                entries: []
              });
            }
            salesOfficeGroups.get(x.SalesOfficeCode).entries.push(x);
          });
          this.salesOfficeItems = Array.from(salesOfficeGroups.values());
          this.salesOfficeItems.sort((a, b) => a.sort - b.sort);
          this.salesOfficeLoader = false
        },
        getPlannerItems(){
          if(this.combinedCadData.length > 0 && this.assignedCategory === 'withSalesOffice'){
            this.loadData()
          }
          this.plannersLoader = true
          this.plannerItems=[]
          const salesOfficeCode = this.selectedSalesOffice?.SalesOfficeCode;
          const salesOffice = this.salesOfficeItems.find(item => item.SalesOfficeCode === salesOfficeCode);
          if (salesOffice) {
            this.plannerItems = salesOffice.entries
            this.plannerItems.sort((a, b) => a.EmployeeCode.localeCompare(b.EmployeeCode));
          }
          this.plannersLoader = false
        },
        async loadData(page = {average: 1, plan: 1}) {
          try {
            if (this.loading) return;
            this.loading = true
            const obj = {
              from: this.plannerCodeRange.fromDate,
              to: this.plannerCodeRange.toDate,
              userCategory: this.userInfo['custom:user_category'],
              salesOfficeCode: this.selectedSalesOffice?.SalesOfficeCode,
              employeeCode: this.selectedPlanner?.EmployeeCode || null,
              page: page
            }
            const { data } = await axios.post(`${this.ichijoApi}getCad`, obj, this.userInfo.tokenHeader)
            if(page.average === 1) {
              this.cadData = []
              this.totalCombinedCadData = data.totalAverage
            }
            if(page.plan === 1) {
              this.combinedCadData = []
              this.totalCombinedData = data.totalPlan
            }
            this.pushToFinalData(data)
            this.loading = false
            this.$nextTick(() => {
                this.attachPlanScrollListener();
                this.attachAverageScrollListener();
                this.getTableHeight();
            });
          } catch (error) {
            this.errorNotice(error)
          }
        },
        async printCSV() {
          this.loading = true;
          const dataHeaders = []
          const averageHeaders = []
          if (this.isAdmin) {
            dataHeaders.push(
              { label: this.$t('PlannersInfo.SalesOfficeCode'), value: "SalesOfficeCode" },
              { label: this.$t('header.SalesOffice'), value: "SalesOfficeName" },
              { label: this.$t('PlannersInfo.EmployeeCode'), value: "EmployeeCode" },
              { label: this.$t('PlannersInfo.EmployeeName'), value: "EmployeeName" },
            )
            averageHeaders.push(
              { label: this.$t('PlannersInfo.SalesOfficeCode'), value: "SalesOfficeCode" },
              { label: this.$t('header.SalesOffice'), value: "SalesOfficeName" },
              { label: this.$t('PlannersInfo.EmployeeCode'), value: "EmployeeCode" },
              { label: this.$t('PlannersInfo.EmployeeName'), value: "EmployeeName" },
            );
          }
          dataHeaders.push(
            { label: this.$t('header.CustomerCode'), value: "ConstructionCode" },
            { label: this.$t('header.BuildingType'), value: "HouseType" },
            { label: this.$t('tooltip.Total CAD Request'), value: "cad" },
            { label: this.$t('header.CADPDR'), value: "CadPdr" },
            { label: this.$t('header.CADFinal'), value: "CadFinalPlan" },
            { label: this.$t('header.CADExpress'), value: "CadExpress" },
            { label: this.$t('header.Denki Plan'), value: "denki" },
            { label: this.$t('header.DenkiExpress'), value: "denkiExpress" },
            { label: this.$t('header.Color Perspective'), value: "ExternalPers" },
            { label: "HP", value: "House_presentation" },
            { label: this.$t('header.Structural Investigation(Waku)'), value: "SI_WAKU_DUCT" },
            { label: this.$t('header.Structural Investigation(Jiku)'), value: "SI_JIKU" },
            { label: "ALVS", value: "ALVS" }
          );
          averageHeaders.push(
            { label: this.$t('header.Category')},
            { label: this.$t('tooltip.Total CAD Request'), value: "cad"},
            { label: this.$t('header.CADPDR'), value: "cadPdr"},
            { label: this.$t('header.CADFinal'), value: "cadFinalPlan"},
            { label: this.$t('header.CADExpress'), value: "cadExpress"},
            { label: this.$t('header.Denki Plan'), value: "denki"},
            { label: this.$t('header.DenkiExpress'), value: "denkiExpress"},
            { label: this.$t('header.Color Perspective'), value: "externalPers"},
            { label: "HP", value: "hp"},
            { label: this.$t('header.Structural Investigation(Waku)'), value: "siWaku"},
            { label: this.$t('header.Structural Investigation(Jiku)'), value: "siJiku"},
            { label: "ALVS", value: "alvs"}
          );
          const averageCategoryHeaders = [
            this.$t(`Average.Average Number of Requests`),
            this.$t(`Average.EIGYOUSYO Average`),
            this.$t(`Average.EIGYOUSYO Ranking`),
            this.$t(`Average.ZENKOKU Average`),
            this.$t(`Average.ZENKOKU Ranking`),
          ];

          const obj = {
            from: this.plannerCodeRange.fromDate,
            to: this.plannerCodeRange.toDate,
            userCategory: this.userInfo['custom:user_category'],
            salesOfficeCode: this.selectedSalesOffice?.SalesOfficeCode,
            employeeCode: this.selectedPlanner?.EmployeeCode || null,
          };

          const requestData1 = { ...obj, csvHeaders: dataHeaders };
          const requestData2 = { ...obj, csvHeaders: averageHeaders, categoryHeaders: averageCategoryHeaders };

          try {
            // Initiate both requests simultaneously
            const [response1, response2] = await Promise.all([
              axios.post(`${this.ichijoApi}getCsvData`, requestData1, {
                headers: {
                  'Content-Type': 'application/json',
                  ...this.userInfo.tokenHeader,
                },
                responseType: 'blob',
              }),
              axios.post(`${this.ichijoApi}getCsvAverage`, requestData2, {
                headers: {
                  'Content-Type': 'application/json',
                  ...this.userInfo.tokenHeader,
                },
                responseType: 'blob',
              }),
            ]);

            // Download first CSV
            const url1 = URL.createObjectURL(response1.data);
            const link1 = document.createElement('a');
            link1.href = url1;
            link1.download = 'IchijoSekkeiData_CadRequestData-1.csv';
            document.body.appendChild(link1);
            link1.click();
            document.body.removeChild(link1);
            URL.revokeObjectURL(url1);

            // Download second CSV
            const url2 = URL.createObjectURL(response2.data);
            const link2 = document.createElement('a');
            link2.href = url2;
            link2.download = 'IchijoSekkeiData_CadRequestData-2.csv';
            document.body.appendChild(link2);
            link2.click();
            document.body.removeChild(link2);
            URL.revokeObjectURL(url2);

          } catch (error) {
            this.errorNotice(error);
          } finally {
            this.loading = false;
          }
        },
        pushToFinalData(data) {
          this.combinedCadData = [...this.combinedCadData, ...data.data]
          this.cadData = [...this.cadData, ...data.cadData]
        },
        async loadPlanNextPage() {
          if (this.loading || this.totalCombinedData === this.combinedCadData.length) {
            return;
          }
          this.page.plan += 1;
          await this.loadData(this.page);
        },
        async loadAverageNextPage() {
          if (this.loading || this.totalCombinedCadData === this.cadData.length) {
            return;
          }
          this.page.average += 1;
          await this.loadData(this.page);
        },
        attachPlanScrollListener() {
          const tablePlanRef = document.querySelector('#tablePlanRef');
          if (tablePlanRef) {
            const wrapper = tablePlanRef.querySelector('.v-data-table__wrapper');
            if (wrapper) {
              // Remove previous listener if any
              if (this.wrapperPlanRef) {
                this.wrapperPlanRef.removeEventListener('scroll', this.onScrollPlan);
              }
              wrapper.addEventListener('scroll', this.onScrollPlan);
              this.wrapperPlanRef = wrapper;
            }
          }
        },
        onScrollPlan() {
          if (this.wrapperPlanRef) {
            const wrapper = this.wrapperPlanRef;
            if (wrapper.scrollTop + wrapper.clientHeight >= wrapper.scrollHeight - 10) {
              this.loadPlanNextPage();
            }
          }
        },
        attachAverageScrollListener() {
          const tableAverageRef = document.querySelector('#tableAverageRef');
          if (tableAverageRef) {
            const wrapper = tableAverageRef.querySelector('.v-data-table__wrapper');
            if (wrapper) {
              // Remove previous listener if any
              if (this.wrapperAverageRef) {
                this.wrapperAverageRef.removeEventListener('scroll', this.onScrollAverage);
              }
              wrapper.addEventListener('scroll', this.onScrollAverage);
              this.wrapperAverageRef = wrapper;
            }
          }
        },
        onScrollAverage() {
          if (this.wrapperAverageRef) {
            const wrapper = this.wrapperAverageRef;
            if (wrapper.scrollTop + wrapper.clientHeight >= wrapper.scrollHeight - 10) {
              this.loadAverageNextPage();
            }
          }
        },
        errorNotice(err) {
          Swal.fire({
            icon: "error",
            title: `${this.$i18n.locale == 'ja' ? 'エラー' : 'Error' }`,
            text: `${err.message}`,
          });
          this.loading=false
        }
      },
      mounted() {
        setTimeout(() => {
          this.fetchData()
        }, 500)
        window.addEventListener('resize', this.getTableHeight)
      },
      computed: {
          monthRestriction() {
            return moment(this.plannerCodeRange.fromDate).add(12,'months').endOf('month').format('YYYY-MM-DD')
          },
          userInfo() {
            return this.$root.decryptedUser;
          },
          isAdmin() {
            const category = this.userInfo['custom:user_category'];
            return ['admin', 'gc admin'].includes(category.toLowerCase());
          },
          hasEmployeeSelected() {
            const employeeCode = this.plannerCodeRange?.Planner?.EmployeeCode || null;
            return employeeCode;
          }
      },
      watch: {
        selectedSalesOffice(newVal) {
          if (newVal === null) {
            this.plannerItems = [];
          }
        },
        assignedCategory(newVal) {
          this.combinedCadData = []
          this.cadData = []
          if (newVal === 'withSalesOffice') {
            this.showPlannerSelection = false
            this.showSalesOfficeSelection = true
            this.selectedSalesOffice = null
            this.selectedPlanner = null
          } else if (newVal === 'allData') {
            this.showPlannerSelection = false
            this.showSalesOfficeSelection = false
            this.selectedSalesOffice = null
            this.selectedPlanner = null
          } else if (newVal === 'planner') {
            this.showPlannerSelection = true
            this.showSalesOfficeSelection = true
          }
        },
      }
  }
</script>

<style>
::selection {
  background-color: #3399ff;  /* Change the background color to simulate the Windows highlight effect */
  color: white;  /* Change the text color for better contrast */
}
.sticky-thead {
  position: sticky;
  z-index: 2;
  background-color: white;
}
.simulate-text-highlight {
  background-color: #3399ff;  /* Change the background color to simulate the Windows highlight effect */
  color: white;  /* Change the text color for better contrast */
}
.TableStyle {
  border: 1px solid black;
}
.last-row td{
  background: white;
}
.center {
  position: absolute;
  top: 50%;
  width: 100%;
  text-align: center;
}
.backColor {
background-color: rgb(163, 147, 147);
}

.cnter{
  position:absolute;
  width: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.header {
  text-wrap:wrap;
  background-color: #01579b; 
  color: white !important;
}

.borderStyle {
  border: 1px solid black;
}
</style>
